// CHAT NOT IN USE for ActionMenu logic
// CHAT moved to SubMenuType
// Customer API logic uses Chat type
export enum SideContainerType {
  NONE = 0,
  CHAT = 1,
  ACTION_MENU = 2,
}
